import React,{ Component } from 'react';
import { Link } from "react-router-dom";
import {Helmet} from "react-helmet";

class Dashboard extends Component {
	constructor(props) {
        super(props);
    }

	render() {
		return (
        <>  
            <Helmet>
                <meta charSet="utf-8" />
                <title>Somerset Cafe | Settings</title>
            </Helmet>
            <div className='row'>
                <div className='col-sm-12'>
                    <h5>Settings</h5>
                </div>
            </div>
            <div className='row mt-15'>
                <div className='col-sm-12 col-md-6 col-lg-3 mb-3'>
                    <div className='card'>
                        <div class="card-body text-center">
                            <h6 className='text-center'>Email Setting</h6>
                            <div className='mt-4 text-right'><Link to="/setting/email" style={{'color' : '#233b90'}}>Configure <i class="fa fa-angle-right" aria-hidden="true"></i></Link></div>
                        </div>
                    </div>
                </div>
                <div className='col-sm-12 col-md-6 col-lg-3 mb-3'>
                    <div className='card'>
                        <div class="card-body text-center">
                            <h6 className='text-center'>Business Hours</h6>
                            <div className='mt-4 text-right'><Link to="/setting/business-hours" style={{'color' : '#233b90'}}>Configure <i class="fa fa-angle-right" aria-hidden="true"></i></Link></div>
                        </div>
                    </div>
                </div>
                <div className='col-sm-12 col-md-6 col-lg-3 mb-3'>
                    <div className='card'>
                        <div class="card-body text-center">
                            <h6 className='text-center'>Menu</h6>
                            <div className='mt-4 text-right'><Link to="/setting/menu" style={{'color' : '#233b90'}}>Configure <i class="fa fa-angle-right" aria-hidden="true"></i></Link></div>
                        </div>
                    </div>
                </div>
                <div className='col-sm-12 col-md-6 col-lg-3 mb-3'>
                    <div className='card'>
                        <div class="card-body text-center">
                            <h6 className='text-center'>Table booking</h6>
                            <div className='mt-4 text-right'><Link to="/setting/table-booking" style={{'color' : '#233b90'}}>Configure <i class="fa fa-angle-right" aria-hidden="true"></i></Link></div>
                        </div>
                    </div>
                </div>
                {/* <div className='col-sm-12 col-md-6 col-lg-3 mb-3'>
                    <div className='card'>
                        <div class="card-body text-center">
                            <h6 className='text-center'>Api log Setting</h6>
                            <div className='mt-4 text-right'><Link to="/setting/api-log" style={{'color' : '#233b90'}}>Configure <i class="fa fa-angle-right" aria-hidden="true"></i></Link></div>
                        </div>
                    </div>
                </div> */}
               
            </div>
        </>    
    );
}
}

export default Dashboard;
